import React from 'react';
import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';
import { InvoiceDeliveryNotificationsUi } from './ui';
import { useInvoiceDeliveryNotifications } from './useInvoiceDeliveryNotifications';

const InvoiceDeliveryNotificationsUiWithHandlers = withLoadingAndNoConnectionHandler(InvoiceDeliveryNotificationsUi);

export const InvoiceDeliveryNotifications: React.FC = () => {
    const { data, isLoading } = useInvoiceDeliveryNotifications();
    return (
        <InvoiceDeliveryNotificationsUiWithHandlers isLoading={isLoading} invoiceDeliveries={data} hasError={false} />
    );
};
